var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12 col-md-10" }, [
    _c("div", { staticClass: "w-100 d-flex align-items-center mb-5" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-9" },
        [_c("SelectConversionMinutes", { attrs: { disabled: false } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "w-100 d-flex" }, [
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-12 col-md-9 d-md-flex flex-md-row justify-content-md-between",
        },
        [
          _c("div", { staticClass: "col-12 col-md-5 mb-4 md-mb-0" }, [
            _c("div", { staticClass: "bg-white p-3" }, [
              _c("div", [
                _vm._m(3),
                _vm._v(" "),
                this.productPriceString
                  ? _c("div", { staticClass: "mb-2 fw-bold" }, [
                      _c("strong", [_vm._v(_vm._s(this.productPriceString))]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.productPriceString
                  ? _c(
                      "div",
                      { staticClass: "mb-3 text-secondary fw-lighter" },
                      [
                        _c("small", [
                          _vm._v(
                            "= " +
                              _vm._s(this.unitPrice) +
                              " " +
                              _vm._s(this.currencySymbol) +
                              " per credit"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !this.productPriceString
                ? _c(
                    "span",
                    { staticClass: "w-100 d-flex justify-content-center mb-4" },
                    [
                      _c("span", {
                        staticClass:
                          "spin-circle-basic spin-circle-225 spin-circle-medium",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary w-100",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.goToChoosePayment.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Buy")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(4),
          ]),
          _vm._v(" "),
          _vm._m(5),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3 text-left" }, [
      _c("h5", { staticClass: "text-left" }, [_vm._v("Quantity:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3 d-md-none" }, [
      _c("h5", [_vm._v("Plan:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3 d-none d-md-flex" }, [
      _c("h5", [_vm._v("Plan:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-3 text-uppercase fw-bold" }, [
      _c("strong", [_vm._v("package")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("small", { staticClass: "fw-lighter" }, [
        _c("strong", [_vm._v("Packages")]),
        _vm._v(" are "),
        _c("strong", [_vm._v("one time")]),
        _vm._v(" payments and your quota will\n                        "),
        _c("strong", [_vm._v("not expire.")]),
        _vm._v(
          '\n                        You can buy any amount of Credits and use them whenever you like ("Pay As You\n                        Go").\n                    '
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 col-md-5" }, [
      _c("div", { staticClass: "bg-white p-3" }, [
        _c("div", [
          _c("div", { staticClass: "mb-3 text-uppercase fw-bold" }, [
            _c("strong", [_vm._v("subscription")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-2 fw-bold" }, [
            _c("strong", [_vm._v("00,00")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3 text-secondary fw-lighter" }, [
            _c("small", [_vm._v("=0,000 $ per Credit")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "button",
            { staticClass: "btn btn-primary w-100", attrs: { disabled: "" } },
            [_vm._v("Coming Soon")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("small", { staticClass: "fw-lighter" }, [
          _c("strong", [_vm._v("Subscriptions")]),
          _vm._v(
            " charge you every month for fixed amount of Credits. Not used Credits "
          ),
          _c("strong", [_vm._v("do not roll over")]),
          _vm._v(
            " at the end of the month. In exchange they are up to 50% cheaper than packages.\n                    "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }